<template>
  <v-app-bar app clipped-left elevate-on-scroll elevation="4" color="primary">
    <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <a href="/">
        <v-img contain src="/logo.svg" width="150" />
      </a>
    </v-toolbar-title>
    <v-toolbar-title>
      <a href="/">
        <h3 class="title-font">Belső szabályozástár</h3>
      </a>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-toolbar-items>
      <Profile v-if="isLoggedIn" />
      <v-btn v-else dark text link href="/login">
        Bejelentkezés
      </v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "AppBar",
  computed: {
    ...mapGetters("Navigation", ["drawer", "expand"]),
    ...mapGetters("Auth", ["isLoggedIn"])
  },
  methods: {
    ...mapMutations("Navigation", ["SET_DRAWER", "SET_EXPAND"]),
    toggleDrawer() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.SET_DRAWER(!this.drawer);
      } else {
        this.SET_EXPAND(!this.expand);
      }
    }
  }
};
</script>

<style>
.title-font {
  font-family: BMETitle, "Roboto Thin", sans-serif;
  color: #231f20;
  margin-left: 20px;
  cursor: pointer;
}
</style>
